import { useContext } from 'react';
import { PromotionVariantContext } from './promotion-variant-context';
export function usePromotionVariantContext() {
    var contextValues = useContext(PromotionVariantContext);
    if (!contextValues) {
        throw new Error('used outside the context provider usePromotionVariantContext');
    }
    return contextValues;
}
